import {toast} from "react-toastify";
import {t} from "i18next";

const defaultAutoClose = 1700;

export const toaster = {
  success: (text, autoClose = defaultAutoClose) => {
    toast.success(t(text), {autoClose, toastId: text});
  },
  error: (text, autoClose = defaultAutoClose) => {
    toast.error(t(text), {autoClose, toastId: text});
  },
  warning: (text, autoClose = defaultAutoClose) => {
    toast.warning(t(text), {autoClose, toastId: text});
  },
  info: (text, autoClose = defaultAutoClose) => {
    toast.info(t(text), {autoClose, toastId: text});
  },
};
